import React from 'react';
import Modal from 'react-modal';
import Row from '../tag/Row';
import OTButtonGroup from '../tag/OTButtonGroup';
import OTButton from '../tag/OTButton';
import modal from '../../definitions/Modal';
import { FormattedMessage } from 'react-intl';
import OTIcon from "../tag/OTIcon";

const notificationModal = modal({ content: { width: '500px' } });

const HpaBeginModal = (props) => {
  let { hideModal, goToHpa, ...rest } = props;
  return (
    <Modal {...rest} ariaHideApp={false} style={notificationModal}>
      <Row>
        <p>
          <FormattedMessage id="hpa.confirm.navigation" />
        </p>
          <p className="hpa-begin-modal-info-text">
              <FormattedMessage
                  id="hpa.confirm.additional.information"
                  values={{
                      a: (chunks) => (
                          <a
                              href="https://www.suomi.fi/valtuudet"
                              target="_blank"
                              rel="noreferrer"
                              className="hpa-begin-modal-info-text-link"
                          >
                              {chunks}
                              <OTIcon
                                  config={{
                                      type: 'fa',
                                      name: 'icon-external-link',
                                      color: 'default',
                                  }}
                              />
                          </a>
                      ),
                      br: < br/>
                  }}
              />
          </p>

      </Row>
      <Row>
        <OTButtonGroup type="big" fullWidth={true}>
          <OTButton key="cancel" onClick={hideModal}>
            <FormattedMessage id="cancel" />
          </OTButton>
          <OTButton key="submit" onClick={goToHpa}>
            <FormattedMessage id="continue" />
          </OTButton>
        </OTButtonGroup>
      </Row>
    </Modal>
  );
};

export default HpaBeginModal;
